import { DataTable } from '@/components/features/shared/DataTable'
import type { ColumnDef } from '@tanstack/react-table'
import { PaymentRow } from './PaymentRow'

interface PaymentTableProps {
  columns: ColumnDef<PaymentRow, unknown>[]
  rows: PaymentRow[]
  setSelectedPaymentId: (id: string) => void
  setShowPaymentModal: (show: boolean) => void
  onRowClick?: (row: PaymentRow) => void
  groupKey?: (row: PaymentRow) => string
  groupCells?: string[]
}

export const PaymentRowsTable = ({
  columns,
  rows,
  setSelectedPaymentId,
  setShowPaymentModal,
  onRowClick,
  groupKey,
  groupCells,
}: PaymentTableProps) => (
  <DataTable
    columns={columns}
    data={rows}
    onRowClick={(row) => {
      setSelectedPaymentId(row.id)
      setShowPaymentModal(true)
      onRowClick?.(row)
    }}
    groupKey={groupKey}
    groupCells={groupCells}
  />
)
